import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/accessibility/createRequest.ts
import { Exception } from "@wbk/logger";
var createAccessibilityRequest = (_0) => __async(null, [_0], function* ({ body }) {
  try {
    const data = yield fetchClient({
      url: "/accessibility-profile",
      formData: true,
      options: {
        method: "POST",
        body
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "createAccessibilityRequestException"
    });
  }
});

export {
  createAccessibilityRequest
};
//# sourceMappingURL=chunk-TEKJC3FB.mjs.map